module.exports = __webpack_public_path__ + "SP_NarratorVideo_0-f3a8e63854a826ea9c9a5b2cd2bb9316.png";